import { useEffect } from 'react'
import { Grid, Header, Segment } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite';
import PermitContent from './PermitContent';
import PermitDashboardSideContent from './PermitDashboardSideContent';
import PermitDashboardInfo from './PermitDashboardInfo';
import { useStore } from '../../../app/stores/store';

export default observer(function PermitDashboard() {
    const {permitStore} = useStore();
    const {loadPermits} = permitStore;
    // const {sendBasic} = emailStore;

    useEffect( () => {
        loadPermits();
    }, [loadPermits]); 

    return (
        <Segment>
            <Segment basic>
                <Header icon='ship' as='h2' content={'Your WSF Carpool/Vanpool Account Home'} />
                <PermitDashboardInfo />
            </Segment>
            
            <Grid>                    
                <Grid.Column computer={5} tablet={5} mobile={16}>
                    <PermitDashboardSideContent />
                </Grid.Column>

                <Grid.Column computer={11} tablet={11} mobile={16}>
                    <PermitContent />
                </Grid.Column>
            </Grid>
        </Segment>
    )
})